(function () {
  // Global guard to avoid duplicate setup if scripts are re-injected.
  if (window.__ggJdgmCarouselTrackpadInit__) return;
  window.__ggJdgmCarouselTrackpadInit__ = true;

  var CAROUSEL_SELECTOR =
    ".jdgm-widget.jdgm-cards-carousel[data-jdgm-block-id]";
  var BOUND_ATTR = "data-gg-jdgm-wheel-bound";
  var UNBOUND_CAROUSEL_SELECTOR = CAROUSEL_SELECTOR + ":not([" + BOUND_ATTR + "])";
  var HORIZONTAL_INTENT_PX = 6;
  var GESTURE_IDLE_MS = 200;
  var FIRST_STEP_TRIGGER_PX = 42;
  var ADDITIONAL_STEP_TRIGGER_PX = 360;
  var NAV_MIN_INTERVAL_MS = 140;

  function isJudgeMeApiReady() {
    return (
      typeof window.jdgmNextCard === "function" &&
      typeof window.jdgmPreviousCard === "function"
    );
  }

  function normalizeDelta(delta, deltaMode) {
    if (deltaMode === 1) return delta * 16; // lines -> px
    if (deltaMode === 2) return delta * window.innerHeight; // pages -> px
    return delta;
  }

  function getWheelSurface(carousel) {
    return (
      carousel.querySelector(".jdgm-content") ||
      carousel.querySelector(".jdgm-cards-wrapper") ||
      carousel.querySelector(".jdgm-videos-container")
    );
  }

  function bindCarousel(carousel) {
    if (!carousel || carousel.nodeType !== 1) return;
    if (carousel.getAttribute(BOUND_ATTR) === "true") return;

    var blockId = carousel.getAttribute("data-jdgm-block-id");
    if (!blockId) return;

    var wheelSurface = getWheelSurface(carousel);
    if (!wheelSurface) return;

    var gestureDelta = 0;
    var gestureDirection = 0;
    var stepsTriggered = 0;
    var lastWheelAt = 0;
    var lastNavAt = 0;
    var gestureResetTimer = null;

    function resetGesture() {
      gestureDelta = 0;
      gestureDirection = 0;
      stepsTriggered = 0;
      if (gestureResetTimer) {
        clearTimeout(gestureResetTimer);
        gestureResetTimer = null;
      }
    }

    function onWheel(event) {
      if (event.ctrlKey) return; // Ignore pinch zoom gestures.

      var deltaX = normalizeDelta(Number(event.deltaX) || 0, event.deltaMode);
      var deltaY = normalizeDelta(Number(event.deltaY) || 0, event.deltaMode);

      var horizontalIntent =
        Math.abs(deltaX) > Math.abs(deltaY) &&
        Math.abs(deltaX) > HORIZONTAL_INTENT_PX;
      var shiftIntent = event.shiftKey;

      // Keep vertical page scrolling untouched unless intent is horizontal,
      // or Shift+wheel is used (explicit horizontal intent).
      if (!horizontalIntent && !shiftIntent) return;
      if (!isJudgeMeApiReady()) return;

      var horizontalDelta = shiftIntent
        ? Math.abs(deltaX) > Math.abs(deltaY)
          ? deltaX
          : deltaY
        : deltaX;

      if (!horizontalDelta) return;

      event.preventDefault();

      var now = Date.now();
      if (now - lastWheelAt > GESTURE_IDLE_MS) {
        resetGesture();
      }
      lastWheelAt = now;
      if (gestureResetTimer) clearTimeout(gestureResetTimer);
      gestureResetTimer = setTimeout(resetGesture, GESTURE_IDLE_MS);

      var incomingDirection = horizontalDelta > 0 ? 1 : -1;

      // Tiny opposite-sign deltas are often noise in wheel momentum streams.
      if (
        gestureDirection &&
        incomingDirection !== gestureDirection &&
        Math.abs(horizontalDelta) < HORIZONTAL_INTENT_PX * 2
      ) {
        return;
      }

      if (gestureDirection && incomingDirection !== gestureDirection) {
        resetGesture();
        gestureDirection = incomingDirection;
        if (gestureResetTimer) clearTimeout(gestureResetTimer);
        gestureResetTimer = setTimeout(resetGesture, GESTURE_IDLE_MS);
      } else if (!gestureDirection) {
        gestureDirection = incomingDirection;
      }

      gestureDelta += horizontalDelta;

      var nextStepTrigger =
        FIRST_STEP_TRIGGER_PX + stepsTriggered * ADDITIONAL_STEP_TRIGGER_PX;
      if (Math.abs(gestureDelta) < nextStepTrigger) return;
      if (now - lastNavAt < NAV_MIN_INTERVAL_MS) return;

      if (gestureDirection > 0) {
        window.jdgmNextCard(blockId);
      } else {
        window.jdgmPreviousCard(blockId);
      }

      lastNavAt = now;
      stepsTriggered += 1;
    }

    wheelSurface.addEventListener("wheel", onWheel, { passive: false });
    carousel.setAttribute(BOUND_ATTR, "true");
  }

  function bindWithin(root) {
    if (!root) return;

    if (root.matches && root.matches(UNBOUND_CAROUSEL_SELECTOR)) {
      bindCarousel(root);
    }

    if (!root.querySelectorAll) return;
    root.querySelectorAll(UNBOUND_CAROUSEL_SELECTOR).forEach(bindCarousel);
  }

  function init() {
    bindWithin(document);

    window.addEventListener("jdgm.doneSetup", function () {
      bindWithin(document);
    });

    if (window.Shopify && window.Shopify.designMode) {
      document.addEventListener("shopify:section:load", function (event) {
        bindWithin(event.target);
      });
    }
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", init, { once: true });
  } else {
    init();
  }
})();
